import * as React from "react";
import { forwardRef } from "react";
const SvgTabActivity = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0v16h16V0Zm1.455 1.455h13.09v13.09H1.455Zm2.181 2.181v1.455h8.727V3.636Zm0 3.636v1.455h8.727V7.273Zm0 3.636v1.455h8.727v-1.454Z", className: "sc79fc734fd208139cb76f00f8c0dd561__b" }));
const ForwardRef = forwardRef(SvgTabActivity);
export { ForwardRef as ReactComponent };
